/**
 * Неизвестное время рождения — то же правило, что backend/birth_time.py.
 *
 * Без времени рождения недостоверны натальная Луна, Асцендент, Десцендент,
 * MC, IC, куспиды и дома и всё производное от них. Сервер такие точки из
 * расчётов уже убирает; здесь — подписи и проверка для того, что экран
 * рисует сам (колесо карты, линии аспектов).
 */

export const BIRTH_TIME_CAPTION =
  'Время рождения не указано, поэтому Луна, Асцендент и дома не учитываются.';
export const BIRTH_TIME_CAPTION_TRANSITS =
  'Время рождения не указано, поэтому аспекты к Луне, Асценденту и домам не учитываются.';

const TIME_DEPENDENT = new Set([
  'MOON', 'ЛУНА', 'ASC', 'ASCENDANT', 'DSC', 'DESC', 'DESCENDANT', 'MC', 'IC',
  'PART_OF_FORTUNE', 'PARS_FORTUNAE', 'FORTUNA', 'VERTEX',
]);

export function isTimeDependent(name) {
  const n = String(name || '').trim().toUpperCase().replace(/[\s-]+/g, '_');
  return TIME_DEPENDENT.has(n);
}

/** Карта посчитана без времени рождения. */
export function chartTimeUnknown(chart) {
  return !!(chart && (chart.time_unknown || (chart.birthData && chart.birthData.time_unknown)));
}
